export const isDemoMode = import.meta.env.VITE_DEMO_MODE === 'true';

export const demoModeLabel = 'Demo Mode - data simulasi, perubahan tidak disimpan ke server';
